module.exports = __webpack_public_path__ + "img/middle-level.0b11ad41.png";